export default {
  pageHeroV1: {
    container: {
      height: '55vh',
      width: '100%',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      alignItems: 'center',
      justifyContent: 'center'
    },

    content: {
      flexDirection: 'column',
      color: 'white',
      textAlign: 'center',
      h1: {
        variant: 'customVariants.title'
      },
      h2: {
        marginBottom: 4
      }
    }
  }
}
